import { useLayoutEffect, useRef, useState } from "react";

export function ChartFrame({ className, children, testId }) {
  const frameRef = useRef(null);
  const [size, setSize] = useState(null);

  useLayoutEffect(() => {
    const frame = frameRef.current;
    if (!frame) return undefined;
    const measure = () => {
      const { width, height } = frame.getBoundingClientRect();
      if (width > 1 && height > 1) {
        const next = { width: Math.floor(width), height: Math.floor(height) };
        setSize(current => current?.width === next.width && current?.height === next.height ? current : next);
      }
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(frame);
    return () => observer.disconnect();
  }, []);

  return <div ref={frameRef} className={className} data-testid={testId}>{size ? children(size) : null}</div>;
}
